module.exports = __webpack_public_path__ + "static/media/youtube.98242b50.webp";